import { render } from "./InjuryUnitAlysis.vue?vue&type=template&id=406baed8&scoped=true"
import script from "./InjuryUnitAlysis.vue?vue&type=script&lang=js"
export * from "./InjuryUnitAlysis.vue?vue&type=script&lang=js"

import "./InjuryUnitAlysis.vue?vue&type=style&index=0&id=406baed8&lang=scss&scoped=true"
import "./InjuryUnitAlysis.vue?vue&type=style&index=1&id=406baed8&lang=scss&scoped=true"
import "./InjuryUnitAlysis.vue?vue&type=style&index=2&id=406baed8&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406baed8"]])

export default __exports__